var App = App || {};

App.Form = (() => {
    'use strict';

    const init = (id) => {
        const widget = document.getElementById(id);
        const form = widget.querySelector('form');

        // Make file uploader "delete file" link keyboard accessible
        const textButtons = form.querySelectorAll('.ktc-uploader-text-button');
        textButtons.forEach(button => {
            button.setAttribute('href', '#');
            button.addEventListener('click', (e) => {
                e.preventDefault();
            });
        });

        // If the form has been modified for custom validation, send it that way
        if (form.hasAttribute('data-zag-validate-form')) {
            App.SharedFormValidation.Init(form);
        }
    }

    return {
        init
    };
})();